import * as Curator from './curator';
import $ from "jquery";
import 'jquery-inview';

$(".dna-socialmediawall").one('inview', function (event, isInView) {
    if ($('body').hasClass('t3-pid--1')) {
        var postsPerPage = 3;
        var showNetworks = false;
        if ($('.dna-socialmediawall__linkwrap').length > 0) {
            var showLoadMore = false;
        } else {
            var showLoadMore = true;
        }

    } else {
        var postsPerPage = 12;
        var showNetworks = true;
        var showLoadMore = true;
    }
    let curatorteaser = new Curator.Widgets.Waterfall({
        gridWidth: 520,    // sets the desired column width
        animate: true,     // should the posts animate in?
        animateSpeed: 400,
        container: '#curator-feed-seaside',
        feedId: 'ab641346-2eba-4e47-99d9-c89a993cab93',
        lang: $('body').data('lang'),
        templatePost: 'my-post-template',
        postClickAction: 'open-popup',    // what to do when a post is clicked - open-popup | goto-source | nothing
        postClickReadMoreAction: 'open-popup',
        templateFilter: 'filter',
        templatePopup: 'popup',
        templatePopupWrapper: 'popup-wrapper',
        postsPerPage: postsPerPage,
        waterfall: {
            gridWidth: 420,    // sets the desired column width
            animate: false,     // should the posts animate in?
            animateSpeed: 400,
            showLoadMore: showLoadMore
        },
        filter: {
            showNetworks: showNetworks,         // show Networks filter bar
            showSources: false           // show Sources filter bar
        }
    });
    $('.smw').find('.loader').css('display', 'none');
});


// WEBPACK FOOTER //
// ./source/js/modules/lib/social-media-wall.js